import '../../js/config.js';
import '../../js/initSideNav.js';
import '../../js/translations.js';
import '../../js/utils/TokenManager.js';
import { startMyGalleryPage } from '../../js/create/myGalleryPage.js';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => startMyGalleryPage());
} else {
  startMyGalleryPage();
}
